import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Home, Phone, Check, Shield, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

const PHONE_NUMBER = "306-262-5995";

const ResidentialPage = () => {
  const services = [
    { title: "Home Lockouts", desc: "Locked out? We'll get you back inside quickly and safely without damage to your locks." },
    { title: "Lock Replacement", desc: "Upgrade your old or damaged locks with modern, secure alternatives." },
    { title: "Rekeying Services", desc: "Moving into a new home? We'll rekey all your locks so only your keys work." },
    { title: "Smart Lock Installation", desc: "Go keyless with modern smart locks - control access from your phone." },
    { title: "Deadbolt Installation", desc: "Add an extra layer of security with professional deadbolt installation." },
    { title: "Security Assessments", desc: "Free home security evaluation to identify vulnerabilities." },
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-20 px-4 md:px-8 relative">
        <div className="absolute inset-0 bg-[url('https://images.pexels.com/photos/20901468/pexels-photo-20901468.jpeg')] bg-cover bg-center opacity-20"></div>
        <div className="max-w-7xl mx-auto text-center relative z-10">
          <div className="inline-flex items-center gap-2 bg-blue-900/80 border border-blue-700 rounded-sm px-6 py-3 mb-6">
            <Home className="w-6 h-6 text-amber-400" />
            <span className="text-white font-semibold text-lg">Residential Services</span>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white mb-6">
            Home Locksmith <span className="text-amber-400">Saskatoon</span>
          </h1>
          <p className="text-slate-300 text-lg max-w-2xl mx-auto mb-8">
            Keep your family safe with our professional residential locksmith services. From emergency lockouts to complete home security upgrades.
          </p>
          <a href={`tel:${PHONE_NUMBER.replace(/-/g, "")}`}>
            <Button className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold text-lg px-8 py-6">
              <Phone className="w-5 h-5 mr-2" />
              Call Now: {PHONE_NUMBER}
            </Button>
          </a>
        </div>
      </section>

      {/* Services */}
      <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-3xl text-white text-center mb-12">Our Residential Services</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, idx) => (
              <div key={idx} className="bg-slate-800 border border-slate-700 rounded-sm p-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-sm flex items-center justify-center mb-4">
                  <Check className="w-6 h-6 text-amber-400" />
                </div>
                <h3 className="text-white font-bold text-xl mb-2">{service.title}</h3>
                <p className="text-slate-400">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 px-4 md:px-8 bg-slate-800">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-3xl text-white text-center mb-12">Why Choose Us for Your Home</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <Shield className="w-16 h-16 text-amber-400 mx-auto mb-4" />
              <h3 className="text-white font-bold text-xl mb-2">Licensed & Insured</h3>
              <p className="text-slate-400">Fully licensed professionals you can trust in your home.</p>
            </div>
            <div className="text-center">
              <Clock className="w-16 h-16 text-amber-400 mx-auto mb-4" />
              <h3 className="text-white font-bold text-xl mb-2">Fast Response</h3>
              <p className="text-slate-400">15-30 minute arrival for emergency lockouts.</p>
            </div>
            <div className="text-center">
              <Home className="w-16 h-16 text-amber-400 mx-auto mb-4" />
              <h3 className="text-white font-bold text-xl mb-2">Family Owned</h3>
              <p className="text-slate-400">Local family business serving Saskatoon families.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 md:px-8 bg-amber-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-3xl text-slate-900 mb-4">Locked Out of Your Home?</h2>
          <p className="text-slate-700 text-lg mb-8">We're available 24/7 for emergency lockouts. Call now!</p>
          <a href={`tel:${PHONE_NUMBER.replace(/-/g, "")}`}>
            <Button className="bg-slate-900 hover:bg-slate-800 text-white font-bold text-xl px-10 py-6">
              <Phone className="w-6 h-6 mr-3" />
              {PHONE_NUMBER}
            </Button>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ResidentialPage;
